










import {
    Vue,
    Component,
    Prop,
    Provide,
    Emit,
    Watch,
    Inject,
} from "vue-property-decorator";
import echart from 'echarts';
import Empty from './Empty.vue'
@Component({
    components: {Empty},
})

export default class LineView extends Vue {
    @Prop()
    public name!:string;
    @Prop()
    public width!: Number;
    @Prop()
    public height!: Number;
    @Prop()
    public labelName!: string;
    @Prop()
    public lineCorlor!: string;
    @Prop()
    public data? : Array<any>;
    public mychart : any;
    public show : boolean = true;

    @Watch('data',{deep: true})
    public dataChange(newVal : any,oldVal : any) {
            if (!newVal || newVal.length > 0) {
            if(!this.show) {
                this.show = true;
            }
            setTimeout(() => {
                this.draw();
                this.drawTwo();
            }, 100);
            
        }
    }

    public drawTwo() {
        // 基于准备好的dom，初始化echarts实例
var myChart = echart.init(document.getElementById('main') as any);

    
// 指定图表的配置项和数据
var option = {
    title: {
        text: '带中位线的柱状图'
    },
    tooltip: {
        trigger: 'item'
    },
    legend: {
        data:['销量']
    },
        dataZoom: [{
            type: 'slider', // 设置为滑动条型式
            show: true, // 显示dataZoom组件
            start: 0, // 默认显示的起始位置为0
            end: 50, // 默认显示的结束位置为100
            handleSize: 2, // 滑动条的手柄大小
            handleStyle: {
            color: '#DCE2E8' // 滑动条的手柄颜色
            },
            xAxisIndex: [0], // 表示控制第一个x轴
        //   filterMode: 'filter' // 设置为filter模式，即数据超过范围时会被过滤掉
        }],
    xAxis: {
        data: ["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子","dsssd","dsssd","dsssd","dsssd","dsssd","dsssd","dsssd","dsssd","dsssd"],
        axisLabel : {
                    // rotate: 40,
                    width:30,
                    interval: 0
                }
    },
    yAxis: {
            boundaryGap: [0, '50%']
    },
    series: [{
        name: '销量',
        type: 'bar',
        data: [5, 20, 36, 10, 10, 20, 20, 20, 20, 20, 20, 20],
        barWidth:'20%',
        markLine: {
            label:{
                    position : 'middle',
                    formatter: function(value:any) {
                    return '全国平均量'
                    }
            },
            silent:false,
            data: [
                // {type: 'average', name: '全国平均量'}
                    {
            type: 'average',
            name: '平均值',
            yAxis: 17.63,
            label:{
                normal: {
                    formatter: function(params:any){
                        //显示平均值
                        return '全国平均量'
                    }
                }
            },
            //把平均线的位置也设为平均值
        },
            ]
        },
        
    },
    // {
        // name: '销量',
        // type: 'line',
        // yAxisIndex: 0,
        // data: [17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63],
        // barWidth:'20%',
        // markLine: {
        //     label:{
        //          position : 'end',
        //          formatter: function(value) {
        //             return '全国平均量'
        //          }
        //     },
        //     silent:false,
        //     data: [
        //         // {type: 'average', name: '全国平均量'}
        //          {
        //     type: 'average',
        //     name: '平均值',
        //     label:{
        //         normal: {
        //             formatter: function(params){
        //                 //显示平均值
        //                 return '平均值'
        //             }
        //         }
        //     },
        //     //把平均线的位置也设为平均值
        // },
        //     ]
        // },
        
    // },
    //  {
    //   name: 'Temperature',
    //   type: 'line',
    //   yAxisIndex: 1,
    //   tooltip: {
    //     // valueFormatter: function (value) {
    //     //   return value + ' °C';
    //     // }
    //   },
    //    data: [17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63, 17.63],
    // }
    ]
};
//@ts-ignore
myChart.setOption(option);

    }

    public draw() {
        let dom = document.getElementById(this.name) as any;
        dom.style.height = this.height  + 'px';
        this.mychart = echart.init(dom);
        let option = {
            color: [this.lineCorlor],
            legend: {
                data: ['数量'],
                formatter: this.labelName,
            },
                tooltip: {
                trigger: 'axis'
                },
                grid: {
                x: 45,
                y: 25,
                x2: 25,
                y2: 60
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: this.data?.map(value => value.date),
                axisLabel : {
                    rotate: 40
                }
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                data: this.data?.map(value => value.num),
                name: '数量',
                type: 'line',
                areaStyle: {
                    opacity: 0.1
                },
                    markLine: {
            data: [
                {type: 'average', name: '平均值'}
            ]
        }
                },
                
            ]
        };
        
        this.mychart.setOption(option);
    }

    public resize() {
        if (this.show) {
            this.mychart.resize();
        }
    }


    mounted() {
        if (!this.data || this.data.length == 0) {
            this.show = false;
        }
        window.addEventListener('resize',()=> {
                this.resize()
        })
        const tempThis = this as any;
        if(tempThis.$bus) {
        tempThis.$bus.$on('collapseChange',() => {
        setTimeout(() => {
            this.resize()
        }, 300);
        });
        }
    }
}
